module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fzg-about-mobile"
  }, [_c('div', {
    staticClass: "fzg-banner"
  }, [_c('fzg-menu'), _vm._v(" "), _c('img', {
    staticClass: "banner-bg",
    attrs: {
      "src": require("../../assets/img2/mobile/about/banner.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "banner-intro",
    attrs: {
      "src": require("../../assets/img2/mobile/about/intro.jpg"),
      "alt": ""
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "section fzg-about-intro"
  }, [(false) ? [_c('img', {
    staticClass: "eco-title",
    attrs: {
      "src": require("../../assets/img2/pc/about/fzg-about-title-intro.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "intro-title-line"
  }), _vm._v(" "), _vm._m(0, false, false)] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "intro-profile"
  }, [_c('div', {
    staticClass: "pro-item-list swiper-container profileSwiper"
  }, [_c('div', {
    staticClass: "pro-item swiper-wrapper"
  }, _vm._l((_vm.profileData), function(item) {
    return _c('div', {
      staticClass: "swiper-slide pro-swiper-item"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "line"
    }), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.source))])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "profile-arrow-line"
  }, [_c('div', {
    staticClass: "aa-left",
    on: {
      "click": function($event) {
        _vm.onClickLeftSwiper()
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "aa-right",
    on: {
      "click": function($event) {
        _vm.onClickRightSwiper()
      }
    }
  })])])], 2), _vm._v(" "), _c('div', {
    staticClass: "fzg-teams-g4"
  }, [_c('img', {
    staticClass: "team-person",
    attrs: {
      "src": require("../../assets/img2/mobile/about/team.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "team-data"
  }, [_c('div', {
    staticClass: "person-item",
    on: {
      "click": function($event) {
        _vm.showPartner(0)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "person-item",
    on: {
      "click": function($event) {
        _vm.showPartner(1)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "person-item",
    on: {
      "click": function($event) {
        _vm.showPartner(2)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "person-item",
    on: {
      "click": function($event) {
        _vm.showPartner(3)
      }
    }
  })])]), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _vm._m(2, false, false), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.isShowPartnerModal) ? _c('fzg-about-partner-modal', {
    attrs: {
      "partner-index": _vm.partnerIndex
    },
    on: {
      "hide-modal": function($event) {
        _vm.isShowPartnerModal = false
      }
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "intro-content"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/img2/pc/about/fzg-about-logo.jpg")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('p', [_vm._v("凡卓集团成立于2014年，依托独有的创投生态体系，扎根产业实体。面向高质量的科创城市、创业者、机构投资者、产业专家、行业从业者、科创巨头企业，提供财务顾问、直接投资、创业孵化、创投媒体、产业咨询、商机对接、创投培训、路演论坛、飞地运营等服务。 ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("凡卓集团的使命是“帮助创业者找人、找钱、找产业政策”，旗下包含小饭桌创服、小饭桌创投、凡卓资本三个板块，其中凡卓资本累计帮助近600家企业完成超800亿元融资，近两年内帮助数百个明星项目完成近300亿元融资。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fzg-advantage"
  }, [_c('img', {
    staticClass: "adv-img",
    attrs: {
      "src": require("../../assets/img2/mobile/about/advantage.jpg"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section fzg-history"
  }, [_c('img', {
    staticClass: "his-img",
    attrs: {
      "src": "https://static-image.xfz.cn/1698580607763/about_us_mobile.jpg"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bf336e94"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/about/FzgAboutMobile.vue
// module id = 240
// module chunks = 0